module.exports = __webpack_public_path__ + "img/contents_title_sub107.384b21bb.png";